/**
 * 虚拟评测引擎
 */
export class VirtualEngine {
  // 日志前缀
  logPrefix = '[VirtualEngine] '
  // 引擎初始化回调方法
  engineCallbackFunc = null
  // 录音结束/停止回调方法
  stopRecordCallbackFunc = null
  // 录音时长定时器
  recordSetTimeout = null
  // 音频数据回调函数
  bufferCallbackFunc = null

  /**
   * 构造参数
   * @param userId 用户id
   * @param callback 引擎初始化回调方法
   * @param bufferCallback 录音内容回调函数
   */
  constructor(userId, callback, bufferCallback) {
    console.log(this.logPrefix + 'init engine')
    this.userId = userId
    this.engineCallbackFunc = callback
    this.bufferCallbackFunc = bufferCallback
    this._init()
    this._connect()
  }

  /**
   * 初始化函数
   */
  _init() {
    if (typeof this.engineCallbackFunc === 'function') {
      // 初始化成功
      const data = {
        state: 1,
        note: 'success'
      }
      this.engineCallbackFunc(data)
    }
  }

  /**
   * 连接引擎
   * @private
   */
  _connect() {
    if (typeof this.engineCallbackFunc === 'function') {
      // 连接成功
      const data = {
        state: 2,
        note: 'success'
      }
      this.engineCallbackFunc(data)
    }
  }

  /**
   * 开始录音
   * @param params
   * @param callback
   */
  startRecord(params, callback) {
    console.log(this.logPrefix + 'start record')
    this.stopRecordCallbackFunc = callback
    const that = this
    // 评测时长，最长10分钟
    const evalTime = params?.evalTime > 0 ? params.evalTime : 10 * 60 * 1000
    // 记录定时器，结束后回调录音结束方法
    this.recordSetTimeout = setTimeout(() => {
      that.execStopRecordCallbackFunc()
    }, evalTime)
  }

  /**
   * 停止录音
   */
  stopRecord() {
    console.log(this.logPrefix + 'stop record')
    this.clearRecordSetTimeout()
    this.execStopRecordCallbackFunc()
  }

  /**
   * 取消录音，不触发回调
   */
  cancelRecord() {
    console.log(this.logPrefix + 'cancel record')
    this.clearRecordSetTimeout()
    this.stopRecordCallbackFunc = null
  }

  /**
   * 销毁引擎
   */
  destroyEngine() {
    console.log(this.logPrefix + 'destroy engine')
    this.clearRecordSetTimeout()
  }

  /**
   * 清理录音定时器
   */
  clearRecordSetTimeout() {
    if (this.recordSetTimeout) {
      clearTimeout(this.recordSetTimeout)
      this.recordSetTimeout = null
    }
  }

  /**
   * 执行停止录音回调方法
   */
  execStopRecordCallbackFunc() {
    if (this.stopRecordCallbackFunc && typeof this.stopRecordCallbackFunc === 'function') {
      this.stopRecordCallbackFunc()
    }
  }
}
